(ns frontend.actions.email
  (:require [frontend.conn :as conn]
            [promesa.core :as p]
            [common.util :as cu]))

(defn *->send-email [data on-success! on-error!]
  (-> (conn/sendp! :email/send (cu/remove-nil-vals data))
      (p/then on-success!)
      (p/catch on-error!)))
